


























































































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Se importa el objeto 'firebase' que contiene el SDK
import { firebase } from "@/config/firebase";

// Importamos los componentes y tipos necesarios
import TablaFactura from "@/components/facturas/Tabla.vue";
import FormularioFactura from "@/components/facturas/Formulario.vue";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoFactura from "@/components/facturas/Info.vue";
import VentasSistema from "@/components/facturas/VentasSistema.vue";
import NotaCreditoFactura from "@/components/facturas/NotaCredito.vue";
import PagoFactura from "@/components/facturas/Pago.vue";
import {
  PagoFactura as PagoFacturaDoc,
  estadoSegunCobro,
  pagosDeFactura,
  saldoPorCobrar,
  totalPagado,
} from "@/helpers/pagosFacturas";
import { NotaCreditoFactura as NotaCreditoFacturaDoc, cubreTodaLaFactura } from "@/helpers/notasCredito";

type RegistroNota = NonNullable<NotaCreditoFacturaDoc["historial"]>[number];
import {
  EstadoFactura,
  Factura,
  FacturaItem,
  RegistroHistorialFactura,
} from "@/typings/store/plugins/easyFirestore/facturas";
import { DataFormularioFactura } from "@/typings/components/facturas/formulario";
import { Contrato } from "@/typings/store/plugins/easyFirestore/contratos";
import ExportarExcelGenerico from "@/components/ExportarExcelGenerico.vue";
import ExportarPdfGenerico from "@/components/ExportarPdfGenerico.vue";

import { indicadorService } from "@/services/indicadorService";
import {
  DivisionCalculo,
  ItemCalculado,
  aFecha,
  aNumero,
  calcularItemDivision,
  calcularItemsCondicion,
  periodoAnterior,
  proporcionDelMes,
  totalesDeItems,
  diaUfDesdeLiquidacion,
  fechaUf,
  requiereUf,
  vigenteEnPeriodo,
} from "@/helpers/facturacion";
import { Excepcion, ajustarDivisiones, aplicarExcepciones, excepcionesVigentes } from "@/helpers/excepciones";

interface ResumenFacturacion {
  creadas: number;
  yaFacturados: number;
  conPendientes: number;
  conExcepciones: number;
  omitidos: Array<{ contrato: string; motivo: string }>;
}
interface EstadoVentas {
  periodo: string;
  cargadas: number;
  completo: number;
  "con-huecos": number;
  incompleto: number;
  "sin-registro": number;
  sinVinculo: number;
}
export type AccionFactura = "aprobar" | "volver-borrador" | "emitir" | "anular" | "pagar" | "nota-credito" | "registrar-pago";

const COLECCION_NOTAS = "dev/v1/notasCreditoFacturas";
const COLECCION_PAGOS = "dev/v1/pagosFacturas";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["facturas"]) {
    return true;
  }
  const rutas = vm.getRutasUsuario;
  if (rutas?.length > 0 && rutas[0].to) {
    if (vm.$route.name !== rutas[0].to.name) vm.$router.replace(rutas[0].to);
    return false;
  }
  if (vm.$route.name !== "inicio") vm.$router.replace({ name: "inicio" });
  return false;
};

@Component({
  computed: mapGetters({
    getUsuario: "usuario/get",
    getRutasUsuario: "usuario/getRutas",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaFactura,
    FormularioFactura,
    InfoFactura,
    ExportarExcelGenerico,
    ExportarPdfGenerico,
    VentasSistema,
    NotaCreditoFactura,
    PagoFactura,
  },
})
export default class VistaFacturas extends Vue {
  // Propiedades del componente
  cargando = false;
  periodo = new Date().toISOString().substr(0, 7);
  menuFecha = false;
  search = "";
  items: Factura[] = [];
  factura: Factura | null = null;
  dialogoExito = { model: false, texto: "", icono: "" };
  dialogoInfo = false;

  readonly estados: EstadoFactura[] = ["Borrador", "Aprobada", "Emitida", "Pagada", "Anulada"];
  filtroPeriodo = "";
  filtroEstados: EstadoFactura[] = [];
  dialogoEmitir: { model: boolean; factura: Factura | null; folio: number | null; error: string } = {
    model: false,
    factura: null,
    folio: null,
    error: "",
  };
  notasCredito: NotaCreditoFacturaDoc[] = [];
  pagos: PagoFacturaDoc[] = [];
  dialogoPago: { model: boolean; factura: Factura | null } = { model: false, factura: null };
  dialogoAnularPago: { model: boolean; pago: PagoFacturaDoc | null; motivo: string; error: string } = {
    model: false,
    pago: null,
    motivo: "",
    error: "",
  };
  dialogoNotaCredito: { model: boolean; factura: Factura | null } = { model: false, factura: null };
  dialogoFolioNota: { model: boolean; nota: NotaCreditoFacturaDoc | null; folio: number | null; error: string } = {
    model: false,
    nota: null,
    folio: null,
    error: "",
  };
  dialogoAnular: { model: boolean; factura: Factura | null; motivo: string; error: string } = {
    model: false,
    factura: null,
    motivo: "",
    error: "",
  };

  get opcionesPeriodo(): Array<{ text: string; value: string }> {
    const periodos = Array.from(new Set(this.items.map((f) => f.periodoFacturado))).sort().reverse();
    return [{ text: "Todos los periodos", value: "" }, ...periodos.map((p) => ({ text: p, value: p }))];
  }

  get itemsDelPeriodo(): Factura[] {
    return this.filtroPeriodo
      ? this.items.filter((f) => f.periodoFacturado === this.filtroPeriodo)
      : this.items;
  }

  get itemsFiltrados(): Factura[] {
    return this.filtroEstados.length
      ? this.itemsDelPeriodo.filter((f) => this.filtroEstados.includes(f.estado))
      : this.itemsDelPeriodo;
  }

  get conteoPorEstado(): Record<string, number> {
    const conteo: Record<string, number> = {};
    this.itemsDelPeriodo.forEach((f) => (conteo[f.estado] = (conteo[f.estado] || 0) + 1));
    return conteo;
  }

  get porRevisar(): number {
    return this.items.filter((f) => f.estado === "Borrador").length;
  }

  get itemsExportacion(): Array<Record<string, unknown>> {
    const fecha = (iso: string) => (iso ? new Date(iso).toLocaleDateString("es-CL") : "");
    return this.itemsFiltrados.map((f) => ({
      periodo: f.periodoFacturado,
      contrato: f.codigoContrato ?? "",
      cliente: f.clienteSnapshot?.nombre ?? "",
      rut: f.clienteSnapshot?.rut ?? "",
      estado: f.estado,
      folio: f.folio ?? "",
      detalle: (f.items || []).map((i) => `${i.glosa}: $${i.montoNeto}`).join(" | "),
      montoNeto: f.montoNeto,
      montoIva: f.montoIva,
      montoTotal: f.montoTotal,
      pagado: totalPagado(this.pagos, f.id),
      saldo: ["Emitida", "Pagada"].includes(f.estado) ? saldoPorCobrar(f, this.notasCredito, this.pagos) : "",
      vencimiento: fecha(f.fechaVencimiento),
    }));
  }

  get columnasExportacionFacturas(): Array<{ label: string; field: string }> {
    return [
      { label: "Periodo", field: "periodo" },
      { label: "Contrato", field: "contrato" },
      { label: "Cliente", field: "cliente" },
      { label: "RUT", field: "rut" },
      { label: "Estado", field: "estado" },
      { label: "Folio", field: "folio" },
      { label: "Detalle", field: "detalle" },
      { label: "Monto neto", field: "montoNeto" },
      { label: "Monto IVA", field: "montoIva" },
      { label: "Monto total", field: "montoTotal" },
      { label: "Pagado", field: "pagado" },
      { label: "Saldo por cobrar", field: "saldo" },
      { label: "Vencimiento", field: "vencimiento" },
    ];
  }
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTA FACTURA (BORRADOR)?";
  dialogoConfirmacion: {
    model: boolean;
    texto: string;
    resolve: ((value: boolean) => void) | null;
  } = {
    model: false,
    texto: "",
    resolve: null,
  };
  valorUfActual: number | null = null;
  valorDolarActual: number | null = null;
  cacheUf: Record<string, number | null> = {};
  dialogoResumen = false;
  resumen: ResumenFacturacion | null = null;
  dialogoVentas = false;
  autoVentas = true;
  /** Resultado de la carga automática de ventas; null si no hay sesión, false mientras carga. */
  estadoVentas: EstadoVentas | null | false = false;

  get ventasPendientes(): number {
    const e = this.estadoVentas;
    return e ? e.incompleto + e["sin-registro"] + e.sinVinculo : 0;
  }

  /** Vuelve a montar la carga automática para que el aviso refleje lo recién guardado. */
  refrescarEstadoVentas(): void {
    this.autoVentas = false;
    this.$nextTick(() => (this.autoVentas = true));
  }

  cerrarVentas(): void {
    this.dialogoVentas = false;
    this.refrescarEstadoVentas();
  }

  /** Muestra "—" mientras el indicador no carga o si la API no respondió. */
  formatearIndicador(valor: number | null): string {
    return valor === null ? "—" : valor.toCurrency({ symbol: "$" });
  }

  // --- Propiedades Computadas para acceder a Firebase ---
  get db(): firebase.firestore.Firestore {
    return firebase.firestore();
  }

  // --- CICLO DE VIDA ---
  async created(): Promise<void> {
    if (!routeGuard(this)) return;
    // Los indicadores se piden en paralelo: la API externa puede tardar y no debe frenar la tabla.
    indicadorService.getUfValue(new Date()).then((v) => (this.valorUfActual = v));
    indicadorService.getDolarValue(new Date()).then((v) => (this.valorDolarActual = v));
    await this.fetchFacturas();
  }

  // --- MÉTODOS DE DATOS ---
  async fetchFacturas(): Promise<void> {
    this.cargando = true;
    try {
      const querySnapshot = await this.db.collection("dev/v1/facturas").get();
      const facturasLeidas: Factura[] = [];
      querySnapshot.forEach((doc) => {
        facturasLeidas.push({ id: doc.id, ...doc.data() } as Factura);
      });
      // Periodo más reciente primero; dentro del periodo, por cliente.
      facturasLeidas.sort(
        (a, b) =>
          String(b.periodoFacturado ?? "").localeCompare(String(a.periodoFacturado ?? "")) ||
          (a.clienteSnapshot?.nombre ?? "").localeCompare(b.clienteSnapshot?.nombre ?? "")
      );
      this.items = facturasLeidas;
      const snapNotas = await this.db.collection(COLECCION_NOTAS).get();
      this.notasCredito = snapNotas.docs.map((d) => ({ ...(d.data() as NotaCreditoFacturaDoc), id: d.id }));
      const snapPagos = await this.db.collection(COLECCION_PAGOS).get();
      this.pagos = snapPagos.docs.map((d) => ({ ...(d.data() as PagoFacturaDoc), id: d.id }));
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error("Error al cargar las facturas:", error);
    } finally {
      this.cargando = false;
    }
  }

  /** El código de contrato se ha guardado como número y como texto: se buscan ambos. */
  async buscarPorCodigoContrato(
    coleccion: string,
    codigo: number | string
  ): Promise<firebase.firestore.DocumentData[]> {
    const variantes = Array.from(
      new Set<string | number>(
        [codigo, String(codigo), Number(codigo)].filter(
          (v) => v !== "" && !(typeof v === "number" && isNaN(v))
        )
      )
    );
    const snapshot = await this.db
      .collection(coleccion)
      .where("codigo_contrato", "in", variantes)
      .get();
    return snapshot.docs.map((doc) => doc.data());
  }

  async obtenerValorUf(fecha: Date): Promise<number | null> {
    const clave = fecha.toISOString().substr(0, 10);
    if (!(clave in this.cacheUf)) {
      this.cacheUf[clave] = await indicadorService.getUfValue(fecha);
    }
    return this.cacheUf[clave];
  }

  async generarFacturacionMasiva(): Promise<ResumenFacturacion> {
    const resumen: ResumenFacturacion = {
      creadas: 0,
      yaFacturados: 0,
      conPendientes: 0,
      conExcepciones: 0,
      omitidos: [],
    };
    const periodo = this.periodo;
    const [year, month] = periodo.split("-").map(Number);
    const inicioPeriodo = new Date(year, month - 1, 1);
    const finPeriodo = new Date(year, month, 0, 23, 59, 59);
    this.cacheUf = {};

    // Contratos que ya tienen factura en el periodo: se saltan.
    const snapshotExistentes = await this.db
      .collection("dev/v1/facturas")
      .where("periodoFacturado", "==", periodo)
      .get();
    // Una factura anulada (por nota de crédito) no cuenta: el contrato se puede volver a facturar.
    const contratosFacturados = new Set(
      snapshotExistentes.docs
        .map((doc) => doc.data())
        .filter((f) => f.estado !== "Anulada")
        .map((f) => f.idContrato as string)
    );

    // Ventas del mes anterior por contrato, para los cargos variables.
    const periodoVenta = periodoAnterior(periodo);
    const snapshotVentas = await this.db
      .collection("dev/v1/ventasLocatarios")
      .where("periodo", "==", periodoVenta)
      .get();
    const ventasMesAnterior = new Map<string, number>();
    snapshotVentas.docs.forEach((doc) => {
      const v = doc.data();
      const clave = String(v.codigoContrato);
      ventasMesAnterior.set(clave, (ventasMesAnterior.get(clave) || 0) + aNumero(v.ventaNeta));
    });

    // Excepciones por contrato: descuentos y acuerdos especiales con el locatario.
    const snapshotExcepciones = await this.db.collection("dev/v1/excepcionesContrato").get();
    const excepciones = snapshotExcepciones.docs.map((doc) => ({ id: doc.id, ...doc.data() } as Excepcion));

    const snapshotContratos = await this.db
      .collection("dev/v1/contratos")
      .where("estadoContrato", "==", "Vigente")
      .get();

    const contratosActivos = snapshotContratos.docs
      .map((doc) => ({ id: doc.id, ...doc.data() } as Contrato))
      .filter((contrato) =>
        vigenteEnPeriodo(
          aFecha(contrato.fechaInicio),
          aFecha(contrato.fechaFin),
          inicioPeriodo,
          finPeriodo
        )
      )
      .filter((contrato) => !!aFecha(contrato.fechaInicio));

    for (const contrato of contratosActivos) {
      const idContrato = contrato.id ?? "";
      const nombre = `${contrato.codigo} (${contrato.clienteSnapshot?.nombre ?? "sin cliente"})`;
      const omitir = (motivo: string) =>
        resumen.omitidos.push({ contrato: nombre, motivo });

      if (!idContrato) {
        omitir("contrato sin id");
        continue;
      }
      if (contratosFacturados.has(idContrato)) {
        resumen.yaFacturados++;
        continue;
      }
      if (!contrato.clienteSnapshot) {
        omitir("no tiene cliente asociado");
        continue;
      }
      const superficie = aNumero(
        contrato.superficieTotal || contrato.localSnapshot?.superficie
      );
      if (!superficie) {
        omitir("no tiene superficie");
        continue;
      }

      const todasCondiciones = await this.buscarPorCodigoContrato(
        "dev/v1/condicionesComerciales",
        contrato.codigo
      );
      const condiciones = todasCondiciones.filter((c) =>
        vigenteEnPeriodo(
          aFecha(c.desde),
          aFecha(c.hasta),
          inicioPeriodo,
          finPeriodo
        )
      );
      if (condiciones.length === 0) {
        omitir("sin condiciones comerciales vigentes en el periodo");
        continue;
      }

      const divisionesContrato = (await this.buscarPorCodigoContrato(
        "dev/v1/condicionesDivisiones",
        contrato.codigo
      )) as Array<DivisionCalculo & firebase.firestore.DocumentData>;
      // Descuentos en %, "no cobrar" y "solo variable" rebajan las divisiones antes del cálculo.
      // El fijo contra el que OPCION compara el variable es el del mes de la venta, con sus
      // descuentos; "no cobrar" perdona el cargo pero no quita el mínimo del contrato.
      const excepcionesMes = excepcionesVigentes(excepciones, contrato.codigo, periodo);
      const divisiones = ajustarDivisiones(divisionesContrato, excepcionesMes);
      const divisionesMesVenta = ajustarDivisiones(
        divisionesContrato,
        excepcionesVigentes(excepciones, contrato.codigo, periodoVenta).filter((e) => e.tipo !== "no-cobrar")
      );

      const itemsFactura: FacturaItem[] = [];
      let error = "";
      const venta = ventasMesAnterior.get(String(contrato.codigo));

      // OPCION compara el variable con el fijo del mes de la venta: el de las condiciones
      // vigentes ESE mes (un descuento que parte este mes no rebaja la base) y con su UF.
      let fijoMesAnterior: number | undefined;
      const usaOpcion = divisiones.some(
        (d) =>
          String(d.nombre_division).toUpperCase() === "ALQUILER VARIABLE" &&
          String(d.operador || "").toUpperCase() === "OPCION" &&
          condiciones.some((c) => String(c.codigo_condicion) === String(d.codigo_condicion))
      );
      if (usaOpcion && venta !== undefined) {
        const [ya, ma] = periodoVenta.split("-").map(Number);
        const inicioAnterior = new Date(ya, ma - 1, 1);
        const finAnterior = new Date(ya, ma, 0, 23, 59, 59);
        fijoMesAnterior = 0;
        for (const c of todasCondiciones) {
          if (!vigenteEnPeriodo(aFecha(c.desde), aFecha(c.hasta), inicioAnterior, finAnterior)) continue;
          const fijos = divisionesMesVenta.filter(
            (d) =>
              String(d.codigo_condicion) === String(c.codigo_condicion) &&
              String(d.nombre_division).toUpperCase() === "ALQUILER FIJO"
          ) as DivisionCalculo[];
          if (!fijos.length) continue;
          const proporcionAnterior = proporcionDelMes(periodoVenta, [
            { desde: aFecha(contrato.fechaInicio), hasta: aFecha(contrato.fechaFin) },
            { desde: aFecha(c.desde), hasta: aFecha(c.hasta) },
          ]);
          if (!proporcionAnterior.dias) continue;
          let ufAnterior: number | null = null;
          if (fijos.some((d) => requiereUf(d))) {
            const dia = aNumero(contrato.dia_uf) || diaUfDesdeLiquidacion(c.liquidacion ?? "") || 1;
            ufAnterior = await this.obtenerValorUf(fechaUf(periodoVenta, dia));
            if (!ufAnterior) {
              error = `no se pudo obtener la UF de ${periodoVenta} para el variable`;
              break;
            }
          }
          fijoMesAnterior += fijos.reduce(
            (s, d) => s + calcularItemDivision(d, superficie, ufAnterior, periodoVenta, proporcionAnterior).montoNeto,
            0
          );
        }
      }

      for (const condicion of condiciones) {
        if (error) break;
        const divisionesCondicion = divisiones.filter(
          (d) => String(d.codigo_condicion) === String(condicion.codigo_condicion)
        );
        // Días del mes en que rigen a la vez el contrato y esta condición (prorrateo).
        const proporcion = proporcionDelMes(periodo, [
          { desde: aFecha(contrato.fechaInicio), hasta: aFecha(contrato.fechaFin) },
          { desde: aFecha(condicion.desde), hasta: aFecha(condicion.hasta) },
        ]);
        if (proporcion.dias === 0) continue;
        let valorUF: number | null = null;
        if (divisionesCondicion.some((d) => requiereUf(d as DivisionCalculo))) {
          const dia =
            aNumero(contrato.dia_uf) ||
            diaUfDesdeLiquidacion(condicion.liquidacion ?? "");
          if (!dia) {
            error = "no tiene día UF en el contrato ni en la liquidación";
            break;
          }
          const fecha = fechaUf(periodo, dia);
          valorUF = await this.obtenerValorUf(fecha);
          if (!valorUF) {
            error = `no se pudo obtener la UF del ${fecha.toLocaleDateString()}`;
            break;
          }
        }
        itemsFactura.push(
          ...calcularItemsCondicion(divisionesCondicion as DivisionCalculo[], {
            superficie,
            valorUF,
            periodo,
            proporcion,
            venta: venta ?? null,
            periodoVenta,
            fijoMesAnterior,
          })
        );
      }

      if (error) {
        omitir(error);
        continue;
      }
      if (itemsFactura.length === 0) {
        omitir("sus condiciones no tienen divisiones");
        continue;
      }
      // Descuento en monto, monto pactado y fijo en $0 de "solo variable", con la glosa explicada.
      const itemsFinales = aplicarExcepciones(itemsFactura as ItemCalculado[], excepcionesMes) as FacturaItem[];
      if (excepcionesMes.length) resumen.conExcepciones++;

      const nuevaFacturaData: Omit<Factura, "id"> = {
        idContrato,
        codigoContrato: contrato.codigo,
        estado: "Borrador",
        fechaEmision: new Date().toISOString(),
        // Vencimiento un mes después de la emisión
        fechaVencimiento: new Date(
          new Date().setMonth(new Date().getMonth() + 1)
        ).toISOString(),
        periodoFacturado: periodo,
        clienteSnapshot: contrato.clienteSnapshot,
        items: itemsFinales,
        ...totalesDeItems(itemsFinales),
        historial: [this.registroHistorial("Borrador", "Generada")],
      };

      const docRef = await this.db
        .collection("dev/v1/facturas")
        .add(nuevaFacturaData);
      this.items.push({ id: docRef.id, ...nuevaFacturaData });
      contratosFacturados.add(idContrato);
      resumen.creadas++;
      if (itemsFinales.some((item) => item.pendiente)) resumen.conPendientes++;
    }

    return resumen;
  }

  async iniciarProceso(): Promise<void> {
    const e = this.estadoVentas;
    const avisoVentas =
      e && this.ventasPendientes
        ? ` Ojo: de las ventas de ${e.periodo} hay ${e.incompleto} incompletas, ${e["sin-registro"]} sin registro` +
          ` y ${e.sinVinculo} contratos sin vincular; su variable quedará con lo cargado hasta ahora o pendiente.`
        : e === null
        ? " El sistema de ventas no está conectado: el variable usará solo las ventas ya cargadas."
        : "";
    const confirm = await this.confirmarAccion(
      `¿Estás seguro de que deseas generar la facturación para el periodo ${this.periodo}?${avisoVentas}`
    );
    if (!confirm) return;

    this.cargando = true;
    try {
      this.resumen = await this.generarFacturacionMasiva();
      this.dialogoResumen = true;
    } catch (error: unknown) {
      if (process.env.NODE_ENV !== "production") console.error("Error en la facturación masiva:", error);
      const err = error as { code?: string };
      let mensaje = "Ocurrió un error inesperado. Revisa la consola.";
      if (err.code === "unavailable") {
        mensaje =
          "No se pudo conectar a la base de datos. Revisa tu conexión a internet y las reglas de seguridad de Firestore.";
      } else if (err.code === "failed-precondition") {
        mensaje =
          "La consulta a la base de datos requiere un índice que no existe. Por favor, crea el índice en la consola de Firebase. El enlace para crearlo está en la consola de desarrollador (F12).";
      }
      alert(mensaje);
    } finally {
      this.cargando = false;
    }
  }

  aceptarConfirmacion(): void {
    if (this.dialogoConfirmacion.resolve)
      this.dialogoConfirmacion.resolve(true);
    this.dialogoConfirmacion.model = false;
  }
  cancelarConfirmacion(): void {
    if (this.dialogoConfirmacion.resolve)
      this.dialogoConfirmacion.resolve(false);
    this.dialogoConfirmacion.model = false;
  }
  confirmarAccion(texto: string): Promise<boolean> {
    this.dialogoConfirmacion.texto = texto;
    this.dialogoConfirmacion.model = true;
    return new Promise((resolve) => {
      this.dialogoConfirmacion.resolve = resolve;
    });
  }

  registroHistorial(estado: EstadoFactura, nota?: string): RegistroHistorialFactura {
    const registro: RegistroHistorialFactura = {
      estado,
      fecha: new Date().toISOString(),
      usuario: this.getUsuario?.email ?? "",
    };
    if (nota) registro.nota = nota;
    return registro;
  }

  /** Actualiza la factura en Firestore y en la tabla, agregando el registro al historial. */
  async actualizarFactura(
    factura: Factura,
    cambios: Partial<Factura>,
    registro: RegistroHistorialFactura
  ): Promise<boolean> {
    if (!factura.id) return false;
    this.cargando = true;
    try {
      const historial = [...(factura.historial || []), registro];
      await this.db
        .collection("dev/v1/facturas")
        .doc(factura.id)
        .update({ ...cambios, historial });
      const index = this.items.findIndex((f) => f.id === factura.id);
      if (index !== -1) this.$set(this.items, index, { ...factura, ...cambios, historial });
      return true;
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error("Error al actualizar la factura:", error);
      alert("No se pudo actualizar la factura. Puede que su estado haya cambiado; recarga la página.");
      return false;
    } finally {
      this.cargando = false;
    }
  }

  async cambiarEstado({ factura, accion }: { factura: Factura; accion: AccionFactura }): Promise<void> {
    if (accion === "aprobar" && factura.estado === "Borrador") {
      if (factura.items.some((i) => i.pendiente)) {
        const seguir = await this.confirmarAccion(
          "Esta factura tiene cargos variables pendientes de ventas en $0. ¿Aprobarla igual?"
        );
        if (!seguir) return;
      }
      await this.actualizarFactura(factura, { estado: "Aprobada" }, this.registroHistorial("Aprobada"));
    } else if (accion === "volver-borrador" && factura.estado === "Aprobada") {
      await this.actualizarFactura(factura, { estado: "Borrador" }, this.registroHistorial("Borrador", "Devuelta a revisión"));
    } else if (accion === "emitir" && factura.estado === "Aprobada") {
      this.dialogoEmitir = { model: true, factura, folio: null, error: "" };
    } else if (accion === "anular" && factura.estado === "Emitida") {
      this.dialogoAnular = { model: true, factura, motivo: "", error: "" };
    } else if (accion === "registrar-pago" && factura.estado === "Emitida") {
      this.dialogoPago = { model: true, factura };
    } else if (accion === "nota-credito" && (factura.estado === "Emitida" || factura.estado === "Pagada")) {
      this.dialogoNotaCredito = { model: true, factura };
    } else if (accion === "pagar" && factura.estado === "Emitida") {
      const ok = await this.confirmarAccion(`¿Marcar la factura ${factura.folio} como pagada?`);
      if (ok) await this.actualizarFactura(factura, { estado: "Pagada" }, this.registroHistorial("Pagada"));
    }
  }

  async confirmarEmision(): Promise<void> {
    const { factura, folio } = this.dialogoEmitir;
    if (!factura) return;
    if (!folio || !Number.isInteger(folio) || folio <= 0) {
      this.dialogoEmitir.error = "Ingresa el folio que asignó Softland";
      return;
    }
    const repetida = this.items.find(
      (f) => f.id !== factura.id && f.folio === folio && f.estado !== "Anulada"
    );
    if (repetida) {
      this.dialogoEmitir.error = `El folio ${folio} ya está en la factura de ${repetida.clienteSnapshot?.nombre} (${repetida.periodoFacturado})`;
      return;
    }
    const ok = await this.actualizarFactura(
      factura,
      { estado: "Emitida", folio, fechaEmision: new Date().toISOString() },
      this.registroHistorial("Emitida", `Folio ${folio}`)
    );
    if (ok) this.dialogoEmitir.model = false;
  }

  moneda(valor: number): string {
    return new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(valor || 0);
  }

  registroNota(estado: NotaCreditoFacturaDoc["estado"], nota?: string): RegistroNota {
    return { estado, fecha: new Date().toISOString(), usuario: this.getUsuario?.email ?? "", ...(nota ? { nota } : {}) };
  }

  /** Si las notas emitidas cubren toda la factura emitida, la factura queda anulada. */
  async anularSiCorresponde(factura: Factura, nota: NotaCreditoFacturaDoc): Promise<void> {
    const emitidas = this.notasCredito.filter((n) => n.estado === "Emitida");
    if (factura.estado !== "Emitida" || !cubreTodaLaFactura(factura, emitidas)) return;
    const motivo = `Nota de crédito ${nota.folio}: ${nota.motivo}`;
    await this.actualizarFactura(factura, { estado: "Anulada", motivoAnulacion: motivo }, this.registroHistorial("Anulada", motivo));
  }

  async guardarNotaCredito({ nota }: { nota: Omit<NotaCreditoFacturaDoc, "id"> }): Promise<void> {
    const factura = this.dialogoNotaCredito.factura;
    if (!factura) return;
    this.cargando = true;
    try {
      const doc: Omit<NotaCreditoFacturaDoc, "id"> = {
        ...nota,
        creadoPor: this.getUsuario?.email ?? "",
        creadoEn: new Date().toISOString(),
        historial: [this.registroNota(nota.estado, nota.folio ? `Folio ${nota.folio}` : "Creada")],
      };
      const ref = await this.db.collection(COLECCION_NOTAS).add(doc);
      const guardada = { ...doc, id: ref.id };
      this.notasCredito = [...this.notasCredito, guardada];
      this.dialogoNotaCredito = { model: false, factura: null };
      if (guardada.estado === "Emitida") {
        await this.anularSiCorresponde(factura, guardada);
        await this.actualizarEstadoCobro(factura, "promover");
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error("Error al guardar la nota de crédito:", error);
      alert("No se pudo guardar la nota de crédito. Intenta de nuevo.");
    } finally {
      this.cargando = false;
    }
  }

  abrirFolioNota(nota: NotaCreditoFacturaDoc): void {
    this.dialogoFolioNota = { model: true, nota, folio: null, error: "" };
  }

  async confirmarFolioNota(): Promise<void> {
    const { nota, folio } = this.dialogoFolioNota;
    if (!nota?.id) return;
    if (!folio || !Number.isInteger(folio) || folio <= 0) {
      this.dialogoFolioNota.error = "Ingresa el folio que asignó Softland";
      return;
    }
    const repetida = this.notasCredito.find((n) => n.id !== nota.id && n.folio === folio && n.estado !== "Anulada");
    if (repetida) {
      this.dialogoFolioNota.error = `El folio ${folio} ya está en otra nota de crédito (${repetida.clienteSnapshot?.nombre})`;
      return;
    }
    this.cargando = true;
    try {
      const cambios = {
        estado: "Emitida" as const,
        folio,
        fechaEmision: new Date().toISOString(),
        historial: [...(nota.historial || []), this.registroNota("Emitida", `Folio ${folio}`)],
      };
      await this.db.collection(COLECCION_NOTAS).doc(nota.id).update(cambios);
      const emitida = { ...nota, ...cambios };
      this.notasCredito = this.notasCredito.map((n) => (n.id === nota.id ? emitida : n));
      this.dialogoFolioNota.model = false;
      const factura = this.items.find((f) => f.id === nota.idFactura);
      if (factura) {
        await this.anularSiCorresponde(factura, emitida);
        await this.actualizarEstadoCobro(factura, "promover");
        if (this.factura?.id === factura.id) this.factura = this.items.find((f) => f.id === factura.id) || this.factura;
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error("Error al emitir la nota de crédito:", error);
      this.dialogoFolioNota.error = "No se pudo registrar el folio. Intenta de nuevo.";
    } finally {
      this.cargando = false;
    }
  }

  /** Saldo de las facturas emitidas (lo que falta cobrar). */
  get porCobrar(): { monto: number; facturas: number } {
    const saldos = this.items
      .filter((f) => f.estado === "Emitida")
      .map((f) => saldoPorCobrar(f, this.notasCredito, this.pagos))
      .filter((s) => s > 0);
    return { monto: saldos.reduce((a, b) => a + b, 0), facturas: saldos.length };
  }

  /**
   * Ajusta el estado según lo cobrado: "promover" pasa a Pagada si ya no queda saldo;
   * "recalcular" además devuelve a Emitida una pagada que vuelve a tener saldo (pago anulado).
   */
  async actualizarEstadoCobro(factura: Factura, modo: "promover" | "recalcular"): Promise<void> {
    const actual = this.items.find((f) => f.id === factura.id) || factura;
    const saldo = saldoPorCobrar(actual, this.notasCredito, this.pagos);
    const hayPagos = pagosDeFactura(this.pagos, actual.id).length > 0;
    const nuevo = estadoSegunCobro(actual.estado, saldo, hayPagos);
    if (!nuevo || (nuevo === "Emitida" && modo === "promover")) return;
    const nota = nuevo === "Pagada" ? "Saldo cobrado" : `Vuelve a tener saldo: ${this.moneda(saldo)}`;
    await this.actualizarFactura(actual, { estado: nuevo }, this.registroHistorial(nuevo, nota));
  }

  async guardarPago({ pago }: { pago: Omit<PagoFacturaDoc, "id"> }): Promise<void> {
    const factura = this.dialogoPago.factura;
    if (!factura) return;
    this.cargando = true;
    try {
      const doc: Omit<PagoFacturaDoc, "id"> = {
        ...pago,
        creadoPor: this.getUsuario?.email ?? "",
        creadoEn: new Date().toISOString(),
      };
      const ref = await this.db.collection(COLECCION_PAGOS).add(doc);
      this.pagos = [...this.pagos, { ...doc, id: ref.id }];
      this.dialogoPago = { model: false, factura: null };
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error("Error al registrar el pago:", error);
      alert("No se pudo registrar el pago. Intenta de nuevo.");
      return;
    } finally {
      this.cargando = false;
    }
    await this.actualizarEstadoCobro(factura, "promover");
  }

  abrirAnularPago(pago: PagoFacturaDoc): void {
    this.dialogoAnularPago = { model: true, pago, motivo: "", error: "" };
  }

  async confirmarAnularPago(): Promise<void> {
    const { pago, motivo } = this.dialogoAnularPago;
    if (!pago?.id) return;
    if (motivo.trim().length < 5) {
      this.dialogoAnularPago.error = "Indica el motivo";
      return;
    }
    this.cargando = true;
    try {
      const cambios = {
        estado: "Anulado" as const,
        motivoAnulacion: motivo.trim(),
        anuladoPor: this.getUsuario?.email ?? "",
        anuladoEn: new Date().toISOString(),
      };
      await this.db.collection(COLECCION_PAGOS).doc(pago.id).update(cambios);
      this.pagos = this.pagos.map((p) => (p.id === pago.id ? { ...p, ...cambios } : p));
      this.dialogoAnularPago.model = false;
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error("Error al anular el pago:", error);
      this.dialogoAnularPago.error = "No se pudo anular el pago. Intenta de nuevo.";
      return;
    } finally {
      this.cargando = false;
    }
    const factura = this.items.find((f) => f.id === pago.idFactura);
    if (factura) {
      await this.actualizarEstadoCobro(factura, "recalcular");
      if (this.factura?.id === factura.id) this.factura = this.items.find((f) => f.id === factura.id) || this.factura;
    }
  }

  async eliminarNotaCredito(nota: NotaCreditoFacturaDoc): Promise<void> {
    if (!nota.id || nota.estado !== "Borrador") return;
    const ok = await this.confirmarAccion(`¿Eliminar el borrador de nota de crédito por ${this.moneda(nota.montoTotal)}?`);
    if (!ok) return;
    await this.db.collection(COLECCION_NOTAS).doc(nota.id).delete();
    this.notasCredito = this.notasCredito.filter((n) => n.id !== nota.id);
  }

  async confirmarAnulacion(): Promise<void> {
    const { factura, motivo } = this.dialogoAnular;
    if (!factura) return;
    if (motivo.trim().length < 5) {
      this.dialogoAnular.error = "Indica el motivo de la anulación";
      return;
    }
    const ok = await this.actualizarFactura(
      factura,
      { estado: "Anulada", motivoAnulacion: motivo.trim() },
      this.registroHistorial("Anulada", motivo.trim())
    );
    if (ok) this.dialogoAnular.model = false;
  }

  async clickGuardar(data: DataFormularioFactura): Promise<void> {
    const original = this.items.find((f) => f.id === data.doc.id);
    if (!original || original.estado !== "Borrador") return;
    const { items, fechaVencimiento } = data.doc;
    const totales = totalesDeItems(items);
    const ok = await this.actualizarFactura(
      original,
      { items, fechaVencimiento, ...totales, montoExento: totales.montoExento || 0 },
      this.registroHistorial("Borrador", "Editada")
    );
    if (ok) {
      this.dialogoExito = {
        model: true,
        texto: "¡Borrador editado!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.cerrarDialogoFormulario();
    }
  }

  async clickEliminar(): Promise<void> {
    const factura = this.factura;
    if (!factura?.id) return;
    if (factura.estado !== "Borrador") {
      alert("Solo se pueden eliminar borradores. Una factura emitida se anula.");
      this.cerrarDialogoEliminar();
      return;
    }
    try {
      await this.db.collection("dev/v1/facturas").doc(factura.id).delete();
      this.items = this.items.filter((f) => f.id !== factura.id);
      this.cerrarDialogoEliminar();
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error("Error al eliminar la factura:", error);
      alert("No se pudo eliminar la factura.");
    }
  }

  clickItem(val: { id: string } | null): void {
    this.factura = this.items.find((f) => f.id === val?.id) || null;
  }
  abrirDialogoInfo(factura: Factura): void {
    this.factura = factura;
    this.dialogoInfo = true;
  }
  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.factura = null;
  }
  abrirDialogoFormulario(factura: Factura): void {
    this.factura = factura;
    this.dialogoFormulario = true;
  }
  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.factura = null;
  }
  abrirDialogoEliminar(factura: Factura): void {
    this.factura = factura;
    this.dialogoEliminar = true;
  }
  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.factura = null;
  }
  cerrarDialogoExito(): void {
    this.dialogoExito = { model: false, texto: "", icono: "" };
  }
}
